import { ReadOnlyStepProps } from "../useStepEditor";
import { Field, Input, Title } from "@introist/react-foundation/v2";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../components/atoms";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";

const DescriptionBox = styled.div`
  width: 100%;
  padding: var(--spacing-small) var(--spacing-medium);
  background: var(--palette-surface-subdued);
  border-radius: var(--rounding-small);
  box-sizing: border-box;
  font-family: var(--typography-font-text);

  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

const StatusBadge = styled.span<{ $stateType: string }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: var(--rounding-small);
  font-size: 12px;
  font-weight: 500;
  background: ${({ $stateType }) => {
    switch ($stateType) {
      case "completed":
        return "var(--palette-success-ghosted)";
      case "canceled":
        return "var(--palette-danger-ghosted)";
      default:
        return "var(--palette-primary-ghosted)";
    }
  }};
  color: ${({ $stateType }) => {
    switch ($stateType) {
      case "completed":
        return "var(--palette-success-default)";
      case "canceled":
        return "var(--palette-danger-default)";
      default:
        return "var(--palette-primary-default)";
    }
  }};
`;

export const LinearIssueStepViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step) return <div />;

  const { resolvedTitle, resolvedDescription, resolvedAssignee } = (step.resolvedData ?? {}) as any;
  const executionData = step.executionData as any;

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Issue">
          <Field title="Title">
            <Input
              value={resolvedTitle}
              size="small"
              variant="blended"
              readOnly
              style={{ background: "var(--palette-surface-subdued)" }}
            />
          </Field>
          <Field title="Description">
            <DescriptionBox>
              <ReactMarkdown>{resolvedDescription || ""}</ReactMarkdown>
            </DescriptionBox>
          </Field>
          <Field title="Assignee (optional)">
            <Input
              value={resolvedAssignee || "Unassigned"}
              size="small"
              variant="blended"
              readOnly
              style={{ background: "var(--palette-surface-subdued)" }}
            />
          </Field>
        </StepEditorAccordion>
      </Block>

      {executionData && (
        <Block blended compact>
          <StepEditorAccordion title="Linear Issue" defaultOpen>
            <StepEditorAccordion.Row label="Status">
              <StatusBadge $stateType={executionData.stateType || "unstarted"}>
                {executionData.state || "Unknown"}
              </StatusBadge>
            </StepEditorAccordion.Row>
            {executionData.identifier && (
              <StepEditorAccordion.Row label="Issue">
                {executionData.url ? (
                  <a href={executionData.url} target="_blank" rel="noreferrer">
                    <Title variant="bold">{executionData.identifier}</Title>
                  </a>
                ) : (
                  <Title variant="bold">{executionData.identifier}</Title>
                )}
              </StepEditorAccordion.Row>
            )}
          </StepEditorAccordion>
        </Block>
      )}
    </>
  );
};
